import { Injectable } from '@angular/core'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { TmrODataConfiguration } from '@exchange/services/core/odata/config'
import { ODataService, TransformationService } from 'common-services'

export interface IRemitLineExport extends IModelBase {
  EdiFileRevisionId: number
  ParentId: string
  ParentQualifier: string
  SegmentId: string
  Qualifier: string
  ElementId: number
  OldEdiFileSegmentInformationId: number
  OldValue: string
  NewEdiFileSegmentInformationId: number
  NewValue: string
  CreatedByIdentity: string
  CreatedOnDateTime: Date
}

@Injectable()
export class RemitLineExportTransformationService extends TransformationService<IRemitLineExport> {
  constructor() {
    super()
  }

  responseTransformArray(response: any, method: string): IRemitLineExport[] {
    response = response.map((x, i) => {
      x.Id = `${x.ClaimDocumentId}|${x.ClaimLineId}|${x.ServiceLineId}|${x.FieldName}|${i}`
      return x
    })
    return response
  }
}

@Injectable()
export class RemitLineExportODataService extends ODataService<IRemitLineExport> {
  constructor(
    protected http: HttpClient,
    protected config: TmrODataConfiguration,
    protected idTransformService: RemitLineExportTransformationService
  ) {
    super(http, config, idTransformService)
    // The typo 'Managment' is to match what the BE is exposing.
    this.typeName = 'ExportComparisonView'
  }
}
